var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReply = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M7.988 10.5c3.563 0 6.777-1.634 8.81-4.259C15.863 10.11 12.268 13 7.988 13c-.553 0-1 .447-1 1v1.923l-4.824-4.174 4.824-4.212V9.5c0 .553.447 1 1 1M17.755 1c-.46 0-.863.315-.972.763-.89 3.649-4.02 6.285-7.795 6.684V7.326c0-.706-.419-1.335-1.093-1.64-.73-.333-1.584-.213-2.177.304L.652 10.414c-.393.344-.618.831-.618 1.336 0 .505.225.992.618 1.336l5.066 4.424c.593.517 1.446.637 2.177.304.674-.305 1.093-.934 1.093-1.64v-1.218c5.624-.493 10.046-5.106 10.046-10.706 0-.81-.104-1.646-.308-2.486-.108-.449-.509-.764-.97-.764",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H19.974V20H0z",
    transform: "translate(.034)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReply, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reply.d64b7685.svg";
export { ForwardRef as ReactComponent };